import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { useThemeChanger } from 'cityads-v3/hooks/theme'

import Balaclava from 'cityads-v3/components/Balaclava';
import SetResponseCode from 'cityads-v3/components/Router/SetResponseCode';
import Typography from '@mui/material/Typography'

import { HTTP_STATUS_NOT_FOUND } from 'cityads-v3/utils/apiUtils';

import classes from './NotFound.scss';

const LOGO = require('cityads-v3/static/images/logo.svg');
const LOGO_DARK = require('cityads-v3/static/images/logoDark.svg')

type NotFoundProps = {
  link: string | { pathname: string },
  linkText: string
}

export default function NotFound({
  link,
  linkText,
}: NotFoundProps): JSX.Element {
  const { t } = useTranslation(['main'])
  const themeChanger = useThemeChanger();
  return (
    <>
      <SetResponseCode code={HTTP_STATUS_NOT_FOUND} noOverride />

      <Helmet>
        <title>{t('page404.title')}</title>
      </Helmet>

      <Balaclava
        menuShow={false}
        showFab={false}
      />

      <div className={classes.error404}>
        <div className={classes.container}>
          <div className={classes.text}>
            <Link to="/main" className={classes.logoLink}>
              <img className={classes.logo} alt="CityAds" src={
                themeChanger.theme.palette.mode === 'dark'
                  ? LOGO_DARK
                  : LOGO
              } />
            </Link>

            <Typography component="h1" className={classes.header}>{t('page404.title')}</Typography>

            <div className={classes.content}>
              <Typography>
                {t('page404.description')}
              </Typography>
              <p>
                <Link to={link ?? '/main'} className={classes.linkToMain}>{linkText ?? t('page404.gohome')}</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
